import { render } from "./income-statement-count.vue?vue&type=template&id=ff25c606&scoped=true"
import script from "./income-statement-count.vue?vue&type=script&lang=js"
export * from "./income-statement-count.vue?vue&type=script&lang=js"

import "./income-statement-count.vue?vue&type=style&index=0&id=ff25c606&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff25c606"]])

export default __exports__